import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function initProjectsSlider(): void {
  document.querySelectorAll('.project-slider').forEach((holder) => {
    const swiper = holder.querySelector('.swiper-projects');
    if (swiper) {
      const navNext = holder.querySelector('.swiper-button-next');
      const navPrev = holder.querySelector('.swiper-button-prev');

      // eslint-disable-next-line no-new
      new Swiper(swiper as HTMLElement, {
        modules: [Navigation],
        grabCursor: true,
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: navNext as HTMLElement | null,
          prevEl: navPrev as HTMLElement | null,
        },
        breakpoints: {
          992: {
            slidesPerView: 2,
          },
        },
      });
    }
  });
}
